@if (cardType === cardTypeEnum.Mastercard) {
    <img
        src="assets/svg/mastercard.svg"
        alt="Mastercard"
        class="inline-flex items-center align-middle self-center scale-150"
    />
} @else if (cardType === cardTypeEnum.Visa) {
    <img
        src="assets/svg/visa.svg"
        alt="Visa"
        class="inline-flex items-center align-middle self-center scale-150"
    />
} @else if (cardType === cardTypeEnum.Amex) {
    <img
        src="assets/svg/amex.svg"
        alt="American Express"
        class="inline-flex items-center align-middle self-center scale-150"
    />
}
